$(document).ready(function(){
    var mid_slide = new Swiper(".mid_slide .swiper-container", {
        // speed:1000,
        // loop: true,
        slidesPerView: 2.3,
        // autoplay: {
        //     delay: 3000,
        //     disableOnInteraction: false,
        // },
        spaceBetween: 10,
        slidesOffsetAfter:18,
        breakpoints: {
            1281: {
                spaceBetween: 10,
                slidesPerView: 3,
            },
        },
    });
});